import { equal } from "@wry/equality";

export function arePropsEqual(prevProps: any, nextProps: any): boolean {
  return equal(prevProps, nextProps);
}
